var site = site || {};
site.VideoMonger = (function() {
    var toggleVideos = function(){
        const videoTriggers = document.querySelectorAll(".js-video-trigger");

        videoTriggers.forEach(function(videoTrigger) {
            const btnTrigger = videoTrigger.querySelector("button");
            const videoContainer = videoTrigger.nextElementSibling;
            const video = videoContainer.querySelector(".js-video")
            const closeVideo = videoContainer.querySelector(".js-close-video");
            
            btnTrigger.addEventListener('click', function(){
                playerReady();
            })
    
            closeVideo.addEventListener('click', function(){
                handleClose();
            })  
    
            video.onpause = (event) => {
                handleClose();
            };
    
            const playerReady = function() {
                closeVideo.classList.remove('d-none');
                closeVideo.classList.add('d-flex');
                videoContainer.classList.add('z-index-4');
                video.play();
            }    
    
            const handleClose = function() {
                closeVideo.classList.add('d-none');
                closeVideo.classList.remove('d-flex');
                videoContainer.classList.remove('z-index-4');
                video.pause();
            }
        })
    }

    // Return
    return {
        toggleVideos : toggleVideos
    };
})();